module.exports = __webpack_public_path__ + "static/media/csrddc_bg1.e63e646f.svg";